import React from 'react'
import axios from 'axios'

class Ads extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: []
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'ads'
			}
		}).then( response => {
			this.setState({ items: response.data })
		})
	}

	render() {
		return (
			<section className="container">
				<h2>Playbill Ads</h2>
				{
					this.state.items.map( (item, index) => {
						return (
							<div key={index} className="dynamic">
								<h3>{decodeURIComponent(item.headline)}</h3>
								<p>{decodeURIComponent(item.content)}</p>
							</div>
						)
					})
				}
			</section>
		)
	}
}

export default Ads



// WEBPACK FOOTER //
// ./src/pages/ads.js